export const arrowLeft = {
	className: 'icon-arrow-left',
	viewBox: '0 0 76.267001 128.96201',
	paths: ['m 76.267,128.962 -35.711,0 L 31.793,115.048 9.952,80.333 0,64.483 9.952,48.635 31.793,13.92 40.556,0 76.267,0 35.261,64.482 l 41.006,64.48 z']
}
